import ReducersFactory from '../../lib/reducers/ReducersFactory';

const resultItems = new ReducersFactory('resultItems', [])


export default resultItems.reducer